/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import JavascriptTimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import ReactTimeAgo from "react-time-ago";
import { getStory, getOfflineStory } from "../services/apiHN";
import { formatTimestamp } from "../utils/formatTimestamp";
import { formatCount } from "../utils/formatCount";
import {
  COMMENT_SINGLE,
  COMMENT_MULTIPLE,
  SCORE_SINGLE,
  SCORE_MULTIPLE,
} from "../constants";

JavascriptTimeAgo.addLocale(en);

function Story({ storyId }) {
  const [story, setStory] = useState([]);

  useEffect(() => {
    getStory(storyId)
      .then((data) => data && data.url && setStory(data))
      .catch((error) => {
        getOfflineStory(storyId).then(
          (data) => data && data.url && setStory(data)
        );
      });
  }, []);

  return story && story.url ? (
    <article className="app-story">
      <a
        className="app-story-link"
        href={story.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <header>
          <h1 className="app-story-title link" data-testid="story-title">
            {story.title}
          </h1>
        </header>
        <p className="app-story-url">{story.url}</p>
      </a>
      <footer className="app-story-meta">
        by <span data-testid="story-by">{story.by}</span>{" "}
        <time dateTime={formatTimestamp(story.time)}>
          {<ReactTimeAgo date={new Date(formatTimestamp(story.time))} />}
        </time>
        . It has{" "}
        {
          <a
            href={"https://news.ycombinator.com/item?id=" + story.id}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            {formatCount(story.kids, COMMENT_SINGLE, COMMENT_MULTIPLE)}
          </a>
        }{" "}
        and {formatCount(story.score, SCORE_SINGLE, SCORE_MULTIPLE)}
      </footer>
    </article>
  ) : null;
}

export default Story;
